import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";
import TransitionsModal from "../../components/Modal";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import {
  deleteApi,
  getApi,
  postApi,
  putFormDataApi,
} from "../../config/configAxios";
import Swal from "sweetalert2";
import CustomLoader from "../../components/CustomLoader";
import AdminLayout from "../../layouts/adminLayout/AdminLayout";

const DevelopmentWorkCategory = () => {
  const [data, setData] = useState([]);
  const [storeData, setStoreData] = useState({});
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [openStore, setOpenStore] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // fetch data
  const fetchData = async () => {
    try {
      const res = await getApi(`development-work-category`);
      setData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // handle input
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setStoreData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // store
  const handleStore = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const formData = new FormData();

    formData.append("title_en", storeData.title_en || "");
    formData.append("title_bn", storeData.title_bn || "");
    formData.append("index", storeData.index || "");

    try {
      await postApi(`development-work-category`, formData);

      setOpenStore(false);

      setStoreData({});

      fetchData();

      toast.success("Data created successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Store failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  // delete
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Confirm delete",
      text: "Are you sure you want to delete this?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteApi(`development-work-category/${id}`);

          toast.success("Data deleted successfully!");

          fetchData();
        } catch (err) {
          toast.error(err?.response?.data?.error || "Delete failed");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The item was not deleted.", "info");
      }
    });
  };

  // edit
  const handleEdit = async (id) => {
    setOpenEdit(true);

    try {
      const res = await getApi(`development-work-category/${id}`);

      setEditData(res.data.data);

      setStoreData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    }
  };

  // update
  const handleUpdate = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const formData = new FormData();

    formData.append("id", editData.id);
    formData.append("title_en", storeData.title_en || "");
    formData.append("title_bn", storeData.title_bn || "");
    formData.append("index", storeData.index || "");

    try {
      await putFormDataApi(`development-work-category`, formData);

      setOpenEdit(false);

      setStoreData({});

      fetchData();

      toast.success("Data updated successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout title={"Development Work Category"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div>
          {/* header */}
          <div className="flex justify-between p-3">
            <h1 className="text-gray-700 font-medium">
              Development Work Category List
            </h1>

            <div>
              <button className="btn-indigo" onClick={() => setOpenStore(true)}>
                Add New
              </button>
            </div>
          </div>

          {/* table */}
          <div className="table-wrap">
            <table className="table-main shadow-md">
              <thead className="table-h">
                <tr>
                  <th className="table-h">SN</th>
                  <th className="table-h">Title EN</th>
                  <th className="table-h">Index</th>
                  <th className="table-h">Action</th>
                </tr>
              </thead>

              <tbody className="table-b">
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td className="table-b">{index + 1}</td>

                    <td className="table-b">{item.title_en}</td>

                    <td className="table-b">{item.index}</td>

                    <td className="table-b">
                      <Box display="flex">
                        <IconButton
                          className="mr-3"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Delete className="text-red-500" />
                        </IconButton>

                        <IconButton
                          className="mr-3"
                          onClick={() => handleEdit(item.id)}
                        >
                          <Icon icon={"bxs:edit"} className="text-blue-500" />
                        </IconButton>
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* store modal */}
      <TransitionsModal title={"Add"} open={openStore} setOpen={setOpenStore}>
        <form onSubmit={handleStore}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div className="md:col-span-2">
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>

              <input
                type="text"
                id="title_en"
                name="title_en"
                onChange={handleInputChange}
                placeholder="Title EN"
                className="form-control"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>

              <input
                type="text"
                id="title_bn"
                name="title_bn"
                onChange={handleInputChange}
                placeholder="Title BN"
                className="form-control"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="index" className="font-semibold text-sm">
                Index
              </label>

              <input
                type="text"
                id="index"
                name="index"
                onChange={handleInputChange}
                placeholder="Index"
                className="form-control"
                required
              />
            </div>

            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>

      {/* edit modal */}
      <TransitionsModal title={"Edit"} open={openEdit} setOpen={setOpenEdit}>
        <form onSubmit={handleUpdate}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div className="md:col-span-2">
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>

              <input
                type="text"
                id="title_en"
                name="title_en"
                value={storeData?.title_en || ""}
                onChange={handleInputChange}
                placeholder="Title EN"
                className="form-control"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>

              <input
                type="text"
                id="title_bn"
                name="title_bn"
                value={storeData?.title_bn || ""}
                onChange={handleInputChange}
                placeholder="Title BN"
                className="form-control"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="index" className="font-semibold text-sm">
                Index
              </label>

              <input
                type="text"
                id="index"
                name="index"
                value={storeData?.index || ""}
                onChange={handleInputChange}
                placeholder="Index"
                className="form-control"
                required
              />
            </div>

            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
    </AdminLayout>
  );
};

export default DevelopmentWorkCategory;
